export default "__VITE_ASSET__BeVCtMi7__"